import { WorkHoursEditor } from '@common/WorkHours'

const ModalAddTime = ({ setActive, userId, update, workHours }) => {
  return (
    <WorkHoursEditor
      userId={userId}
      workHours={workHours}
      onClose={() => setActive(false)}
      onSaved={() => update('workHours')}
    />
  )
}

export default ModalAddTime
